
import './styles.scss';

export function setBodyOverflowHidden(overflowHidden = false) {
  document.body.setAttribute('data-overflow', overflowHidden ? 'hidden' : 'auto');
}
